import React from 'react'
import { Link } from 'react-router-dom'
export default function Homepage() {
  return (
    <> <main>
      
    <section  className="slider-area hero-height position-relative fix" data-background="./assets/img/slider/Image.jpg" style={{backgroundImage:"url(assets/img/slider/Image.jpg)"}}>
       <img  className="shape-3 d-none d-xxl-block" src="./assets/img/shape/shape-03.png" alt="image not found"/>
       <div  className="container">
          <div  className="row">
             <div  className="col-xl-6 col-lg-6 col-md-6">
                <div  className="hero-text pt-95">
                   <h5>Discover your journey</h5>
                   <h2>Discover <span  className="down-mark-line"> favorite</span> Courses
                      from top Instructors
                      Around the World</h2>
                   <p>Take your learning organization to the next level. to the next level. Who'll
                      share their knowledge to people around the world.</p>
                   <div  className="hero-btn">
                      <a  className="edu-btn" href="course.html">View all course</a>
                   </div>
                </div>
             </div>
             <div  className="col-xl-6 col-lg-6 col-md-6">
                <div  className="hero-right position-relative">
                   <img data-depth="0.2"  className="shape shape-1" src="assets/img/shape/shape-01.png" alt="shape"/>
                   <img data-depth="0.2"  className="shape-2" src="assets/img/shape/shape-02.png" alt="shape"/>
                   <img  className="shape-6" src="assets/img/shape/slider-shape-6.png" alt="shape"/>
                   <div  className="shape-4">
                      <img  className="" src="assets/img/shape/shape-04.png" alt="shape"/>
                      <h5  className="hero-shape-text">Top Rated
                         Instructors</h5>
                   </div>
                   <div  className="shape-5">
                      <div  className="course-card">
                         <img src="assets/img/shape/slider-card-1.png" alt="image not found"/>
                         <img src="assets/img/shape/slider-card-2.png" alt="image not found"/>
                         <img src="assets/img/shape/slider-card-3.png" alt="image not found"/>
                         <img src="assets/img/shape/slider-card-4.png" alt="image not found"/>
                         <span><i  className="far fa-plus"></i></span>
                      </div>
                      <h5>More than <span>49+</span> students
                         enrolled Tech O Zone</h5>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </section>
    

    
    <div  className="top-catagory-area pt-110 pb-90">
       <div  className="container">
          <div  className="row">
             <div  className="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-12 col-sm justify-content-center mb-30">
                <div  className="section-title mb-20 text-center">
                   <h2>Explore  Our Top <span  className="down-mark-line">Categories</span></h2>
                </div>
             </div>
          </div>







          <div  className="row">
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45.01" viewBox="0 0 45 45.01">
                            <g id="code" transform="translate(-0.061)">
                               <path id="Path_8754" data-name="Path 8754"
                                  d="M29.775,60.8a8.79,8.79,0,0,1-5.352-8.1V28.787A8.777,8.777,0,0,1,33.19,20H27.852a8.791,8.791,0,0,0-8.791,8.791V52.7a8.791,8.791,0,0,0,8.791,8.791h1.886C29.746,61.262,29.758,61.032,29.775,60.8Z"
                                  transform="translate(-17.33 -18.242)" fill="#c8d6f0" />
                               <path id="Path_8755" data-name="Path 8755"
                                  d="M11.753,45.01H10.61A10.561,10.561,0,0,1,.061,34.461V10.549A10.561,10.561,0,0,1,10.61,0H26.786A10.561,10.561,0,0,1,37.335,10.549V22.5a1.758,1.758,0,0,1-3.516,0V10.549a7.041,7.041,0,0,0-7.033-7.033H10.61a7.041,7.041,0,0,0-7.033,7.033V34.461a7.041,7.041,0,0,0,7.033,7.033h1.143A1.758,1.758,0,0,1,11.753,45.01ZM30.214,16.175a1.758,1.758,0,0,0-1.758-1.758H25.467A2.64,2.64,0,0,1,22.83,11.78V8.791a1.758,1.758,0,0,0-3.516,0V11.78a6.161,6.161,0,0,0,6.154,6.154h2.989A1.758,1.758,0,0,0,30.214,16.175Z"
                                  transform="translate(0)" fill="#2467ec" />
                               <path id="Path_8756" data-name="Path 8756"
                                  d="M181.9,329.576a1.758,1.758,0,0,1-1.233-3.011l4.592-4.519a1.747,1.747,0,0,0,0-2.462l-4.6-4.586a1.758,1.758,0,1,1,2.483-2.489l4.6,4.586a5.28,5.28,0,0,1,0,7.446l-.008.008-4.6,4.524A1.753,1.753,0,0,1,181.9,329.576Zm-15.1-.525a1.758,1.758,0,0,0-.02-2.486l-4.592-4.519a1.747,1.747,0,0,1,0-2.463l4.6-4.586a1.758,1.758,0,1,0-2.483-2.489l-4.6,4.585a5.28,5.28,0,0,0,0,7.446l.008.008,4.6,4.524a1.758,1.758,0,0,0,2.486-.02Zm6.59-.747,4.044-14.066a1.758,1.758,0,0,0-3.38-.972l-4.044,14.066a1.758,1.758,0,1,0,3.38.972Z"
                                  transform="translate(-144.217 -284.566)" fill="#ffb013" />
                            </g>
                         </svg>
                      </div>
                      <div  className="catagory-content">
                         <h3>Development</h3>
                         <span>Take your journey with this course</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg id="briefcase" xmlns="http://www.w3.org/2000/svg" width="45" height="45"
                            viewBox="0 0 45 45">
                            <path id="Path_8750" data-name="Path 8750"
                               d="M25.273,163.906V147.031A7.031,7.031,0,0,1,32.3,140H27.031A7.031,7.031,0,0,0,20,147.031v16.875a7.031,7.031,0,0,0,7.031,7.031H32.3A7.031,7.031,0,0,1,25.273,163.906Z"
                               transform="translate(-18.242 -127.695)" fill="#c9d7f1" />
                            <path id="Path_8751" data-name="Path 8751"
                               d="M171.82,7.031a1.758,1.758,0,0,1-1.758-1.758A1.76,1.76,0,0,0,168.3,3.516h-7.031a1.76,1.76,0,0,0-1.758,1.758,1.758,1.758,0,0,1-3.516,0A5.279,5.279,0,0,1,161.273,0H168.3a5.279,5.279,0,0,1,5.273,5.273A1.758,1.758,0,0,1,171.82,7.031Z"
                               transform="translate(-142.289)" fill="#ffb013" />
                            <g id="Group_4443" data-name="Group 4443" transform="translate(0 10.547)">
                               <path id="Path_8752" data-name="Path 8752"
                                  d="M36.211,154.453H8.789A8.8,8.8,0,0,1,0,145.664V128.789A8.8,8.8,0,0,1,8.789,120H36.211A8.8,8.8,0,0,1,45,128.789v16.875A8.8,8.8,0,0,1,36.211,154.453ZM8.789,123.516a5.279,5.279,0,0,0-5.273,5.273v16.875a5.279,5.279,0,0,0,5.273,5.273H36.211a5.279,5.279,0,0,0,5.273-5.273V128.789a5.279,5.279,0,0,0-5.273-5.273Z"
                                  transform="translate(0 -120)" fill="#2467ec" />
                               <path id="Path_8753" data-name="Path 8753"
                                  d="M109.18,196a1.758,1.758,0,0,0-1.758,1.758,5.279,5.279,0,0,1-5.273,5.273H88.789a5.279,5.279,0,0,1-5.273-5.273,1.758,1.758,0,0,0-3.516,0,8.8,8.8,0,0,0,8.789,8.789h4.922V208.3a1.758,1.758,0,1,0,3.516,0v-1.758h4.922a8.8,8.8,0,0,0,8.789-8.789A1.758,1.758,0,0,0,109.18,196Z"
                                  transform="translate(-72.969 -189.32)" fill="#2467ec" />
                            </g>
                         </svg>

                      </div>
                      <div  className="catagory-content">
                         <h3>Business</h3>
                         <span>Take your journey with this course</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg id="collection" xmlns="http://www.w3.org/2000/svg" width="44.998" height="44.998"
                            viewBox="0 0 44.998 44.998">
                            <path id="Path_8761" data-name="Path 8761"
                               d="M25.273,341.834v-.439A4.394,4.394,0,0,1,29.668,337H24.394A4.394,4.394,0,0,0,20,341.394v.439a8.789,8.789,0,0,0,8.789,8.789h5.273A8.789,8.789,0,0,1,25.273,341.834Z"
                               transform="translate(-18.242 -307.382)" fill="#c9d7f1" />
                            <path id="Path_8762" data-name="Path 8762"
                               d="M39.725,24.433a1.758,1.758,0,0,1-1.758-1.758V10.546a7.039,7.039,0,0,0-7.031-7.031H14.062a7.039,7.039,0,0,0-7.031,7.031V22.675a1.758,1.758,0,0,1-3.515,0V10.546A10.558,10.558,0,0,1,14.062,0H30.936A10.558,10.558,0,0,1,41.483,10.546V22.675A1.758,1.758,0,0,1,39.725,24.433Zm-13.271-12.3a2.2,2.2,0,1,0-2.2-2.2A2.2,2.2,0,0,0,26.454,12.128ZM45,34.452v-.439a6.159,6.159,0,0,0-6.152-6.152h-5.7a7.041,7.041,0,0,0-6.3,3.883,4.85,4.85,0,0,1-8.687,0,7.041,7.041,0,0,0-6.3-3.883h-5.7A6.159,6.159,0,0,0,0,34.012v.439A10.558,10.558,0,0,0,10.546,45H34.452A10.558,10.558,0,0,0,45,34.452ZM11.854,31.376A3.5,3.5,0,0,1,15,33.291a8.352,8.352,0,0,0,15,0,3.5,3.5,0,0,1,3.145-1.915h5.7a2.64,2.64,0,0,1,2.637,2.637v.439a7.039,7.039,0,0,1-7.031,7.031H10.546a7.039,7.039,0,0,1-7.031-7.031v-.439a2.64,2.64,0,0,1,2.637-2.637Z"
                               fill="#2467ec" />
                            <path id="Path_8763" data-name="Path 8763"
                               d="M123.758,157.5a1.758,1.758,0,0,1-1.293-2.948s3.5-3.8,3.537-3.834a6.137,6.137,0,0,1,7.93-.251l.023.018,2.673,2.186c1.263.994,2.255.93,3.311-.214l2.528-2.964a1.758,1.758,0,1,1,2.675,2.281s-2.575,3.018-2.588,3.033a5.778,5.778,0,0,1-4.115,2.079,6.174,6.174,0,0,1-4-1.466l-.022-.018-2.673-2.186a2.63,2.63,0,0,0-3.334.067l-3.355,3.648A1.753,1.753,0,0,1,123.758,157.5Z"
                               transform="translate(-111.278 -135.796)" fill="#ffb013" />
                         </svg>
                      </div>
                      <div  className="catagory-content">
                         <h3>Data Science</h3>
                         <span>Discover the data science</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg id="content-marketing" xmlns="http://www.w3.org/2000/svg" width="45" height="45"
                            viewBox="0 0 45 45">
                            <path id="Path_8764" data-name="Path 8764"
                               d="M54.784,57.956l-1.251,1.251L47.37,53.046a10.955,10.955,0,0,1-3-5.6l-1-4.98,4.98,1c.168.034.334.072.5.114l1.316,7.169a10.955,10.955,0,0,0,3,5.6Zm-29.51-6.173V27.877a8.789,8.789,0,0,1,8.789-8.789l18.628-.068,0-.019-23.906.088A8.789,8.789,0,0,0,20,27.877V51.783a8.789,8.789,0,0,0,8.789,8.789l4.575-.028A8.79,8.79,0,0,1,25.273,51.783Z"
                               transform="translate(-18.242 -17.33)" fill="#c9d7f1" />
                            <path id="Path_8765" data-name="Path 8765"
                               d="M27.246,45h-16.7A10.559,10.559,0,0,1,0,34.453V10.547A10.559,10.559,0,0,1,10.547,0H34.453A10.559,10.559,0,0,1,45,10.547V27.378a1.758,1.758,0,1,1-3.516,0V10.547a7.039,7.039,0,0,0-7.031-7.031H10.547a7.039,7.039,0,0,0-7.031,7.031V34.453a7.039,7.039,0,0,0,7.031,7.031h16.7a1.758,1.758,0,1,1,0,3.516Zm15.875-1.879a6.423,6.423,0,0,0,0-9.074l-6.162-6.162a12.672,12.672,0,0,0-6.5-3.477l-4.98-1a1.758,1.758,0,0,0-2.068,2.068l1,4.98a12.673,12.673,0,0,0,3.477,6.5l6.162,6.162a6.416,6.416,0,0,0,9.074,0ZM29.772,27.856a9.167,9.167,0,0,1,4.7,2.515l6.162,6.162a2.9,2.9,0,1,1-4.1,4.1l-6.162-6.162a9.168,9.168,0,0,1-2.515-4.7l-.479-2.4Z"
                               fill="#2467ec" />
                            <path id="Path_8766" data-name="Path 8766"
                               d="M125.664,103.131H109.58a1.758,1.758,0,0,1,0-3.516h16.084a1.758,1.758,0,0,1,0,3.516Zm1.758,5.273a1.758,1.758,0,0,0-1.758-1.758H101.758a1.758,1.758,0,0,0,0,3.516h23.906A1.758,1.758,0,0,0,127.422,108.4Zm-17.578,7.031a1.758,1.758,0,0,0-1.758-1.758h-6.328a1.758,1.758,0,0,0,0,3.516h6.328A1.758,1.758,0,0,0,109.844,115.436ZM100,101.2a2.2,2.2,0,1,0,2.2-2.2A2.2,2.2,0,0,0,100,101.2Z"
                               transform="translate(-91.211 -90.299)" fill="#ffb013" />
                         </svg>

                      </div>
                      <div  className="catagory-content">
                         <h3>Marketing</h3>
                         <span>Take up your self in the next level</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg id="Swimming_Pool" xmlns="http://www.w3.org/2000/svg" width="45" height="45"
                            viewBox="0 0 45 45">
                            <g id="Group_4446" data-name="Group 4446" transform="translate(1.758 12.305)">
                               <path id="Path_8767" data-name="Path 8767"
                                  d="M25.273,163.906V147.031A7.031,7.031,0,0,1,32.3,140H27.031A7.031,7.031,0,0,0,20,147.031v16.875a7.031,7.031,0,0,0,7.031,7.031H32.3A7.031,7.031,0,0,1,25.273,163.906Z"
                                  transform="translate(-20 -140)" fill="#c9d7f1" />
                            </g>
                            <path id="Path_8768" data-name="Path 8768"
                               d="M36.211,10.547H31.289V5.273a1.758,1.758,0,0,1,3.516,0,1.758,1.758,0,0,0,3.516,0,5.273,5.273,0,0,0-10.547,0v5.273H17.227V5.273a1.758,1.758,0,0,1,3.516,0,1.758,1.758,0,0,0,3.516,0,5.273,5.273,0,0,0-10.547,0v5.273H8.789A8.8,8.8,0,0,0,0,19.336V36.211A8.8,8.8,0,0,0,8.789,45H36.211A8.8,8.8,0,0,0,45,36.211V19.336A8.8,8.8,0,0,0,36.211,10.547Zm-8.437,3.516v3.516H17.227V14.063ZM41.484,36.211a5.279,5.279,0,0,1-5.273,5.273H8.789a5.279,5.279,0,0,1-5.273-5.273V19.336a5.279,5.279,0,0,1,5.273-5.273h4.922v11.6a1.758,1.758,0,0,0,3.516,0v-4.57H27.773v4.57a1.758,1.758,0,0,0,3.516,0v-11.6h4.922a5.279,5.279,0,0,1,5.273,5.273Z"
                               fill="#2467ec" />
                            <path id="Path_8769" data-name="Path 8769"
                               d="M105.883,352a1.758,1.758,0,0,0-1.758,1.758,1.758,1.758,0,0,1-3.516,0,1.758,1.758,0,0,0-3.516,0,1.758,1.758,0,0,1-3.516,0,1.758,1.758,0,0,0-3.516,0,1.758,1.758,0,0,1-3.516,0,1.758,1.758,0,0,0-3.516,0,1.758,1.758,0,0,1-3.516,0,1.758,1.758,0,0,0-3.516,0,5.27,5.27,0,0,0,8.789,3.926,5.261,5.261,0,0,0,7.031,0,5.261,5.261,0,0,0,7.031,0,5.27,5.27,0,0,0,8.789-3.926A1.758,1.758,0,0,0,105.883,352Z"
                               transform="translate(-69.32 -321.063)" fill="#ffb013" />
                         </svg>
                      </div>
                      <div  className="catagory-content">
                         <h3>Life Styles</h3>
                         <span>Improved your life style course</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44.991" viewBox="0 0 45 44.991">
                            <g id="no-photo" transform="translate(0 -0.049)">
                               <path id="Path_8770" data-name="Path 8770"
                                  d="M41.972,125.675l-.773.881a8.788,8.788,0,1,1,1.983-17.129A8.81,8.81,0,0,0,41.972,125.675Zm-11.035-23.8-4.15.015A8.787,8.787,0,0,0,18,110.679v14.148a8.787,8.787,0,0,0,8.787,8.787l4.575-.027a8.788,8.788,0,0,1-8.089-8.76V110.679A8.885,8.885,0,0,1,30.937,101.876Z"
                                  transform="translate(-16.418 -92.879)" fill="#c9d7f1" />
                               <path id="Path_8771" data-name="Path 8771"
                                  d="M23.9,42.316H10.545A10.557,10.557,0,0,1,0,31.771V17.624A10.557,10.557,0,0,1,10.545,7.079h1.718l.682-2.106A7.1,7.1,0,0,1,19.714.049h8.647a7.1,7.1,0,0,1,6.77,4.924l.713,2.2a10.6,10.6,0,0,1,9.147,10.453V23.6a1.758,1.758,0,0,1-3.515,0V17.624a7.051,7.051,0,0,0-6.957-7.029A1.757,1.757,0,0,1,32.866,9.38L31.787,6.057a3.591,3.591,0,0,0-3.426-2.493H19.714a3.591,3.591,0,0,0-3.425,2.492L15.213,9.378a1.757,1.757,0,0,1-1.672,1.216h-3a7.038,7.038,0,0,0-7.03,7.03V31.772a7.038,7.038,0,0,0,7.03,7.03H23.9A1.757,1.757,0,0,1,23.9,42.316Zm1.017-6.887a1.758,1.758,0,0,0-.277-3.5,7.047,7.047,0,0,1-7.594-7.008c.289-9.081,13.321-9.412,14.051-.353a1.757,1.757,0,0,0,3.511-.173c-1.1-13.6-20.643-13.093-21.077.526A10.557,10.557,0,0,0,24.077,35.462c.28,0,.564-.011.842-.033Z"
                                  fill="#2467ec" />
                               <path id="Path_8772" data-name="Path 8772"
                                  d="M219.527,83.564h-7.654a1.758,1.758,0,0,1,0-3.515h7.654A1.758,1.758,0,0,1,219.527,83.564Zm11.528,26.362,5.084-5.084a1.758,1.758,0,0,0-2.485-2.486l-5.084,5.084-5.084-5.084A1.758,1.758,0,0,0,221,104.842l5.084,5.084L221,115.01a1.757,1.757,0,0,0,2.485,2.486l5.084-5.084,5.084,5.084a1.757,1.757,0,1,0,2.485-2.486Z"
                                  transform="translate(-191.662 -72.97)" fill="#ffb013" />
                            </g>
                         </svg>
                      </div>
                      <div  className="catagory-content">
                         <h3>Photography</h3>
                         <span>Become the great photographer</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg id="Vector" xmlns="http://www.w3.org/2000/svg" width="45" height="45"
                            viewBox="0 0 45 45">
                            <g id="Group_4444" data-name="Group 4444" transform="translate(8.437 5.273)">
                               <path id="Path_8757" data-name="Path 8757"
                                  d="M102.3,82.877a3.516,3.516,0,0,1-.531-4.292l10.547-16.875a3.526,3.526,0,0,1,.38-.518,3.515,3.515,0,0,0-5.653.518L96.5,78.584a3.515,3.515,0,0,0,.531,4.292l7.031,7.031a3.5,3.5,0,0,0,2.486,1.03h5.273a3.5,3.5,0,0,1-2.486-1.03Z"
                                  transform="translate(-95.997 -60)" fill="#c9d7f1" />
                            </g>
                            <g id="Group_4445" data-name="Group 4445" transform="translate(0)">
                               <path id="Path_8758" data-name="Path 8758"
                                  d="M171.82,472H157.758a1.758,1.758,0,0,0,0,3.516H171.82a1.758,1.758,0,0,0,0-3.516Z"
                                  transform="translate(-142.289 -430.516)" fill="#2467ec" />
                               <path id="Path_8759" data-name="Path 8759"
                                  d="M39.727,0a5.282,5.282,0,0,0-4.971,3.516H10.245a5.273,5.273,0,1,0,0,3.516H17.38l-9.934,15.9-.017.027a5.271,5.271,0,0,0,.8,6.439l7.031,7.031a5.239,5.239,0,0,0,3.729,1.545h7.031a5.239,5.239,0,0,0,3.729-1.545l7.031-7.031a5.272,5.272,0,0,0,.8-6.439l-.017-.027L27.62,7.031h7.136A5.273,5.273,0,1,0,39.727,0ZM5.273,7.031A1.758,1.758,0,1,1,7.031,5.273,1.76,1.76,0,0,1,5.273,7.031Zm18.736.856c.017.029-.47-.752,10.554,16.886a1.758,1.758,0,0,1-.273,2.133l-7.031,7.031a1.747,1.747,0,0,1-1.243.515H18.984a1.746,1.746,0,0,1-1.243-.515L10.71,26.907a1.758,1.758,0,0,1-.273-2.133C21.474,7.114,20.968,7.924,20.991,7.887a1.759,1.759,0,0,1,3.019,0Zm15.717-.856a1.758,1.758,0,1,1,1.758-1.758A1.76,1.76,0,0,1,39.727,7.031Z"
                                  transform="translate(0)" fill="#2467ec" />
                            </g>
                            <path id="Path_8760" data-name="Path 8760"
                               d="M204.789,162.547h-1.758v-8.789a1.758,1.758,0,1,0-3.516,0v8.789h-1.758a1.758,1.758,0,1,0,0,3.516h7.031a1.758,1.758,0,0,0,0-3.516Z"
                               transform="translate(-178.773 -138.641)" fill="#ffb013" />
                         </svg>

                      </div>
                      <div  className="catagory-content">
                         <h3>Art & Design</h3>
                         <span>Grow your design skills</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg id="make" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
                            <path id="Path_8773" data-name="Path 8773"
                               d="M42.061,119.6a4.834,4.834,0,0,1-4.834-4.834V99.834A4.834,4.834,0,0,1,42.071,95l1.376.7a4.809,4.809,0,0,0-1.035,2.988v16.084a4.834,4.834,0,0,0,4.834,4.834Zm-16.655,1.988v.4a5.274,5.274,0,0,1,4.114-5.144l-.2-.129H25.273A5.273,5.273,0,0,0,20,121.982v-.4a4.79,4.79,0,0,0,4.79,4.79H30.2A4.79,4.79,0,0,1,25.405,121.587Z"
                               transform="translate(-18.242 -86.65)" fill="#c9d7f1" />
                            <path id="Path_8774" data-name="Path 8774"
                               d="M7.91,83.426A5.713,5.713,0,1,0,2.2,77.713,5.719,5.719,0,0,0,7.91,83.426Zm0-7.91a2.2,2.2,0,1,1-2.2,2.2A2.2,2.2,0,0,1,7.91,75.516Zm35.332,6.416a1.758,1.758,0,0,0-1.758,1.758v16.875a3.08,3.08,0,0,1-3.076,3.076H6.592a3.076,3.076,0,0,1,0-6.152h5.977a1.757,1.757,0,0,0,.572-3.418,5.713,5.713,0,1,0-9.983.871,6.59,6.59,0,0,0,2.116,12.083v1.89a1.758,1.758,0,0,0,3.516,0v-1.758H36.738v1.758a1.758,1.758,0,0,0,3.516,0v-2.023A6.6,6.6,0,0,0,45,100.564V83.689A1.758,1.758,0,0,0,43.242,81.932ZM7.91,89.578a2.2,2.2,0,1,1-2.2,2.2A2.2,2.2,0,0,1,7.91,89.578Zm9.316,3.955V78.6a6.592,6.592,0,0,1,6.591-6.592h.015a1.758,1.758,0,0,1,0,3.516h-.011A3.076,3.076,0,0,0,20.742,78.6V93.533a3.08,3.08,0,0,0,3.076,3.076H36.211a1.758,1.758,0,0,1,0,3.516H23.818A6.6,6.6,0,0,1,17.227,93.533Z"
                               transform="translate(0 -65.672)" fill="#2467ec" />
                            <path id="Path_8775" data-name="Path 8775"
                               d="M320.789,15.854a5.148,5.148,0,0,1-3.088-1.021c-3.659-2.74-5.631-6.029-5.7-9.513,0-.012,0-.024,0-.036a5.271,5.271,0,0,1,8.789-3.938,5.271,5.271,0,0,1,8.789,3.938c0,.012,0,.024,0,.036-.07,3.483-2.042,6.773-5.7,9.513A5.148,5.148,0,0,1,320.789,15.854ZM315.516,5.268c.07,2.974,2.372,5.312,4.293,6.75a1.645,1.645,0,0,0,1.961,0c1.921-1.438,4.223-3.776,4.293-6.75a1.758,1.758,0,0,0-3.516.005,1.758,1.758,0,0,1-3.516,0,1.758,1.758,0,0,0-3.516-.005Z"
                               transform="translate(-284.578)" fill="#ffb013" />
                         </svg>
                      </div>
                      <div  className="catagory-content">
                         <h3>Health & Fitness</h3>
                         <span>Enjoy the health life with fitness</span>
                      </div>
                   </div>
                </a>
             </div>
             <div  className="col-xl-4 col-lg-6 col-md-6">
                <a href="course.html">

                   <div  className="catagory-wrapper mb-30">
                      <div  className="catagory-thumb">
                         <svg xmlns="http://www.w3.org/2000/svg" width="45" height="42.172" viewBox="0 0 45 42.172">
                            <g id="electric-guitar" transform="translate(0 -18.851)">
                               <path id="Path_8776" data-name="Path 8776"
                                  d="M30.011,203.348a15.8,15.8,0,0,1-4.5-11.3c0-5.045,3.023-7.333,6.337-8.894v-1.913C27.529,183.452,20,184.548,20,192.511a15.385,15.385,0,0,0,15.8,15.8,9.708,9.708,0,0,0,3.461-.584A15.272,15.272,0,0,1,30.011,203.348Z"
                                  transform="translate(-18.163 -149.122)" fill="#c9d7f1" />
                               <g id="Group_4447" data-name="Group 4447" transform="translate(0 18.851)">
                                  <path id="Path_8777" data-name="Path 8777"
                                     d="M44.41,20.885l-1.136-1.051a3.658,3.658,0,0,0-5.109.116L28.5,30.005a1.059,1.059,0,0,1-1.15.251,1.034,1.034,0,0,1-.7-.915,7.077,7.077,0,0,1,.207-2.56,4.725,4.725,0,0,0-.6-4.154,4.909,4.909,0,0,0-3.755-2.1,5.3,5.3,0,0,0-4.264,2.068A18.642,18.642,0,0,0,16.036,26.5a11.708,11.708,0,0,1-1.7,2.981l-.025.025a13.884,13.884,0,0,1-4.136,2.139A22.873,22.873,0,0,0,3.593,35.2,10.327,10.327,0,0,0,0,43.389c0,2.327.492,8.207,5.038,12.6,4.389,4.546,10.269,5.038,12.6,5.038a10.327,10.327,0,0,0,8.185-3.593,22.871,22.871,0,0,0,3.558-6.586,14.063,14.063,0,0,1,2.162-4.159l0,0,0,0a11.735,11.735,0,0,1,2.979-1.694,18.639,18.639,0,0,0,3.908-2.206A5.3,5.3,0,0,0,40.5,38.518a4.909,4.909,0,0,0-2.1-3.755,4.726,4.726,0,0,0-4.154-.6,1.837,1.837,0,0,0,1.115,3.5,1.038,1.038,0,0,1,.949.118,1.245,1.245,0,0,1,.524.924,1.629,1.629,0,0,1-.71,1.218,16.156,16.156,0,0,1-3.143,1.729,13.5,13.5,0,0,0-4.07,2.469,15.954,15.954,0,0,0-2.937,5.349c-1.915,4.758-3.53,7.877-8.335,7.877a14.043,14.043,0,0,1-9.972-3.936l-.052-.052a14.043,14.043,0,0,1-3.936-9.972c0-4.806,3.119-6.42,7.877-8.335a15.951,15.951,0,0,0,5.35-2.938,13.5,13.5,0,0,0,2.468-4.07A16.163,16.163,0,0,1,21.1,24.9a1.633,1.633,0,0,1,1.218-.71,1.246,1.246,0,0,1,.924.523,1.038,1.038,0,0,1,.118.949,10.613,10.613,0,0,0-.369,3.953,4.754,4.754,0,0,0,8.117,2.972L40.78,22.531l1.136,1.051a1.837,1.837,0,1,0,2.494-2.7Z"
                                     transform="translate(0 -18.851)" fill="#2467ec" />
                                  <path id="Path_8778" data-name="Path 8778"
                                     d="M202.537,204.451a1.837,1.837,0,0,0,0,2.6l4.592,4.592a1.837,1.837,0,1,0,2.6-2.6l-4.592-4.592A1.837,1.837,0,0,0,202.537,204.451Z"
                                     transform="translate(-183.447 -188.559)" fill="#2467ec" />
                               </g>
                               <path id="Path_8779" data-name="Path 8779"
                                  d="M101.573,269.179a1.832,1.832,0,0,1-1.3-.538l-4.592-4.592a1.837,1.837,0,0,1,2.6-2.6l4.592,4.592a1.837,1.837,0,0,1-1.3,3.136Zm-3.844,4.605a1.837,1.837,0,0,0,0-2.6l-4.592-4.592a1.837,1.837,0,1,0-2.6,2.6l4.592,4.592a1.837,1.837,0,0,0,2.6,0Z"
                                  transform="translate(-81.734 -221.473)" fill="#ffb013" />
                            </g>
                         </svg>

                      </div>
                      <div  className="catagory-content">
                         <h3>Music</h3>
                         <span>Improve your self with music</span>
                      </div>
                   </div>
                </a>
             </div>
          </div>
       </div>
    </div>
    

    
    <section  className="course-area p-relative pt-110 pb-90">
       <div  className="course-shape-1">
          <img src="assets/img/shape/portfolio-shap-1.png" alt="shape"/>
       </div>
       <div  className="course-shape-2">
          <img src="assets/img/shape/portfolio-shap-2.png" alt="shape"/>
       </div>
       <div  className="course-shape-3">
          <img src="assets/img/shape/portfolio-shap-3.png" alt="shape"/>
       </div>
       <div  className="container">
          <div  className="row">
             <div  className="col-xl-5 col-lg-5 f-left">
                <div  className="section-title mb-50">
                   <h2>Discover
                      World's Best <span  className="down-mark-line">Courses</span></h2>
                </div>
             </div>
           
          </div>

          <section className="course-content-area pb-90 mt-5">
                    <div className="container">
                        <div className="row mb-10">


                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development">
                                                    <img src="assets/img/course/course-01.jpg"
                                                        alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>WordPress Development Course for Plugins & Themes</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                            <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                        {/* <del>$24.50</del> */}
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">WordPress Development Course for Plugins & Themes</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div className="eduman-course-footer">

                                                        <div className="course-deteals-btn">
                                                            <Link className="edo-course-sec-btn text-light" style={{ color: "white" }} target='_blank' to="https://wa.me/9617124507">Apply Now
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>



                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-06.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Basics for Beginners: Learn C & C++ Fundamentals by
                                                                Coding</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                            <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Basics for Beginners: Learn C & C++ Fundamentals by
                                                            Coding</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div className="eduman-course-footer">

                                                        <div className="course-deteals-btn">
                                                            <Link className="edo-course-sec-btn text-light" style={{ color: "white" }} target='_blank' to="https://wa.me/9617124507">Apply Now
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>




                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-11.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Basics for Beginners: Learn Scratch to HTML & Css </h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                            <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Basics for Beginners: Learn Scratch to HTML & Css
                                                        </Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div className="eduman-course-footer">

                                                        <div className="course-deteals-btn">
                                                            <Link className="edo-course-sec-btn text-light" style={{ color: "white" }} target='_blank' to="https://wa.me/9617124507">Apply Now
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>





                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-14.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Understanding Java Script  & jQuery Development </h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                            <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Understanding Java Script  & jQuery Development</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div className="eduman-course-footer">

                                                        <div className="course-deteals-btn">
                                                            <Link className="edo-course-sec-btn text-light" style={{ color: "white" }} target='_blank' to="https://wa.me/9617124507">Apply Now
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>







                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-04.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>MySQL Database : Beginner SQL Database Design</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                            <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>

                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">MySQL Database : Beginner SQL Database Design</Link>
                                                        </h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div className="eduman-course-footer">

                                                        <div className="course-deteals-btn">
                                                            <Link className="edo-course-sec-btn text-light" style={{ color: "white" }} target='_blank' to="https://wa.me/9617124507">Apply Now
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>





                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-12.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Basics for Beginners: Learn Scratch to PHP Development</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                            <Link className="edo-course-sec-btn" target='_blank' to="https://wa.me/9617124507">Apply now</Link>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Basics for Beginners: Learn Scratch to PHP Development</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div className="eduman-course-footer">

                                                        <div className="course-deteals-btn">
                                                            <Link className="edo-course-sec-btn text-light" style={{ color: "white" }} target='_blank' to="https://wa.me/9617124507">Apply Now
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>




                            </div>
                        </div>
                    </div>
                </section>
       </div>
    </section>
    

    
    <div  className="features-area pt-45 pb-15" data-background="assets/img/fact/fact.png">
       <div  className="container">
          <div  className="row">
             <div  className="col-xl-4 col-lg-4 col-md-6">
                <div  className="features-wrapper d-flex align-items-center mb-30">
                   <div  className="features-icon">
                      <i  className="flaticon-online-course"></i>
                   </div>
                   <div  className="features-content">
                      <h3>Learn with skills
                         over 2,420 courses</h3>
                   </div>
                </div>
             </div>
             <div  className="col-xl-4 col-lg-4 col-md-6">
                <div  className="features-wrapper d-flex align-items-center mb-30">
                   <div  className="features-icon">
                      <i  className="flaticon-certificate"></i>
                   </div>
                   <div  className="features-content">
                      <h3>Earn certificates
                         and degrees</h3>
                   </div>
                </div>
             </div>
             <div  className="col-xl-4 col-lg-4 col-md-6">
                <div  className="features-wrapper d-flex align-items-center mb-30">
                   <div  className="features-icon">
                      <i  className="flaticon-laptop"></i>
                   </div>
                   <div  className="features-content">
                      <h3>Learn from
                         anywhere, any time</h3>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
    

    
    <div  className="student-choose-area fix pt-120 pb-110">
       <div  className="container">
          <div  className="row">
             <div  className="col-xl-5 col-lg-5">
                <div  className="student-wrapper">
                   <div  className="section-title mb-30">
                      <h2>Why Students <span  className="down-mark-line">Choose</span> Us for Gain Their Knowledge</h2>
                   </div>
                   <div  className="sitdent-choose-content">
                      <p>Helping employees gain skills and providing career development often take a back seat to
                         business priorities but workplace better right now. Seventy percent of workers think that.
                      </p>
                   </div>
                   <div  className="student-choose-list">
                      <ul>
                         <li><i  className="fas fa-check-circle"></i>Free for physically handcraft </li>
                         <li><i  className="fas fa-check-circle"></i>Easy to enroll courses</li>
                         <li><i  className="fas fa-check-circle"></i>Course certificate for particular course</li>
                      </ul>
                   </div>
                   <div  className="student-btn">
                      <a  className="edu-sec-btn" href="about.html">More about us</a>
                   </div>
                </div>
             </div>
             <div  className="col-xl-2 col-lg-2">
                <div  className="student-wrapper position-relative">
                   <div  className="shap-01">
                   </div>
                </div>
             </div>
             <div  className="col-xl-5 col-lg-5">
                <div  className="student-choose-wrapper position-relative">
                   <div  className="shap-02">
                   </div>
                   <div  className="shap-03">
                      <img src="assets/img/shape/student-shape-03.png" alt="image not found"/>
                   </div>
                   <div  className="shap-04">
                      <img src="assets/img/shape/student-shape-04.png" alt="image not found"/>
                   </div>
                   <div  className="shap-05">
                      <img src="assets/img/shape/student-shape-05.png" alt="image not found"/>
                   </div>
                   <div  className="shap-06">
                      <img src="assets/img/shape/student-shape-06.png" alt="image not found"/>
                   </div>
                   <div  className="shap-07">
                      <img src="assets/img/shape/student-shape-07.png" alt="image not found"/>
                   </div>

                   <div  className="student-choose-thumb">
                      <img src="assets/img/student-choose/student.png" alt="image not found"/>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
    

    
  
    

    
    <div  className="browser-course-area">
       <div  className="container">
          <div  className="row">
             <div  className="col-xl-6 col-lg-6 col-md-12 mb-30">
                <div  className="browser-course-wrapper course-height" data-background="">
                   <div  className="browser-course-bg">
                      <img src="assets/img/browser-course/browser-course-01.jpg" alt="image not found"/>
                   </div>
                   <div  className="browser-course-content">
                      <span>Start from today</span>
                      <div  className="browser-course-tittle">
                         <a href="instructor.html">Become an instructor
                            and spread your knowledge</a>
                      </div>
                      <div  className="browser-btn">
                         <a  className="course-btn" href="become-instructor.html">View details</a>
                      </div>
                   </div>
                </div>
             </div>
             <div  className="col-xl-6 col-lg-6 col-md-12 mb-30">
                <div  className="browser-course-wrapper course-height" data-background="">
                   <div  className="browser-course-bg">
                      <img src="assets/img/browser-course/browser-course-02.jpg" alt="image not found"/>
                   </div>
                   <div  className="row">
                      <div  className="col-xl-7 col-lg-7">
                         <div  className="browser-course-content">
                            <span>Discover your gain</span>
                            <div  className="browser-course-tittle">
                               <a href="course-details.html">Keep your skilled centers of
                                  excellence competitive</a>
                            </div>
                            <div  className="browser-btn">
                               <a  className="course-btn" href="course.html">Browse courses</a>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
    

    
    <section  className="education-area position-relative pt-85">
       <div  className="container">
          <img  className="education-shape-2" src="assets/img/shape/education-shape-04.png" alt="shape"/>
          <img  className="education-shape-3" src="assets/img/shape/education-shape-01.png" alt="shape"/>
          <img  className="education-shape-4" src="assets/img/shape/education-shape-03.png" alt="shape"/>
          <div  className="row">
             <div  className="col-xl-4 col-lg-4 offset-xl-2 offset-lg-2">
                <div  className="education-img mb-30">
                   <img src="assets/img/teacher/education.png" alt="image not found"/>
                </div>
             </div>
             <div  className="col-xl-4 col-lg-4">
                <div  className="section-title mb-30">
                   <h2>Transform Your
                      Life Through <span  className="down-mark-line">Education</span></h2>
                </div>
                <div  className="education-content mb-30">
                   <p>Helping employees gain skills and providing career development often take a back seat to
                      business priorities but workplace.</p>
                   <a  className="edu-sec-btn" href="about.html">Watch how to start</a>
                </div>
             </div>
          </div>
       </div>

    </section>
    

    
 
    
 </main></>
  )
}
